import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {GetFunkprotokollAktuelleVeranstaltungenAction, GetFunkprotokollBeendeteVeranstaltungenAction, GetVeranstaltungenAktuelleAction} from '../../../client-ngrx/veranstaltungen';
import {AuthState} from '@orga-app/auth/reducer';
import {PAGE_DATEN_LADEN, PageLoadDataAction} from './veranstaltung-auswaehlen.actions.ui';
import {AKTUELLE_VERANSTALTUNG_SETZEN, AktuelleVeranstaltungSetzenAction} from '../app-state/actions/veranstaltung.actions';
import {GetZentraleEingangAction, GetZentraleListeAction, GetZentralePinnwandAction} from '../../../client-ngrx/incidents';


@Injectable()
export class VeranstaltungAuswaehlenPageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType<PageLoadDataAction>(PAGE_DATEN_LADEN),
        withLatestFrom(this.store$),
        filter(([x, storeState]) => this.getAuthState(storeState) != null),
        filter(([x, storeState]) => this.getAuthState(storeState).isLoggedIn && !x.payload.funk),
        map(() => {
            return new GetVeranstaltungenAktuelleAction();
        })
    );

    @Effect()
    datenLadenFunk$: Observable<Action> = this.actions$.pipe(
        ofType<PageLoadDataAction>(PAGE_DATEN_LADEN),
        withLatestFrom(this.store$),
        filter(([x, storeState]) => this.getAuthState(storeState) != null),
        filter(([x, storeState]) => this.getAuthState(storeState).isLoggedIn && x.payload.funk),
        flatMap(() => {
            return [
                new GetFunkprotokollAktuelleVeranstaltungenAction(),
                new GetFunkprotokollBeendeteVeranstaltungenAction()
            ];
        })
    );

    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }

    getAuthState(store): AuthState {
        return store['Auth'].auth;
    }
}
